<template>
    <b-row class="main-info-wrapper">
        <b-col cols="8" class="block-info" id="block-info">

            <base-section>
                <b-row>
                    <b-col cols="2" class="d-flex justify-content-start flex-row" style="height: 48px !important;">
                        <div class="d-flex justify-content-center flex-column">
                            <h5 class="mb-0">Kiosk</h5>
                            <h5 class="mt-0">{{ currentDate }}</h5>
                        </div>
                    </b-col>
                    <b-col cols="10" style="height: 48px !important;">
                        <foove-autocomplete @submit="handleSubmit" ref="autocomplete"></foove-autocomplete>
                    </b-col>
                </b-row>
            </base-section>
            <div>
                <div class="kiosk-overlay" v-if="!isAllowToOrder">
                    <span><strong>{{ selectedKioskConsumer.firstname }} {{ selectedKioskConsumer.lastname }}</strong>
                     ist nicht berechtigt, Guthaben im Kiosk zu verwenden</span>
                </div>

                <base-section>
                    <div id="crumbs">
                        <ul>
                            <li @click="backHome"><a class="pl-1 hide-cursor only-first"><img
                                :src="require('../assets/home_icon.svg')" alt="Logo" class="mr-2"
                                style="margin-top: -6px !important;">Alle Kategorien</a>
                            </li>
                            <template v-if="!isOrderHistoryView">
                                <li v-if="parentCategory" @click="levelUp(parentCategory)"><a class="hide-cursor mr-0"
                                                                                              :style="'background-color: #' + parentCategory.color_code + 'D8;'"
                                                                                              id="parent-category-link">
                                    <i class="fa fa-shopping-bag" aria-hidden="true"></i>{{ parentCategory.name }}</a>
                                </li>
                                <li v-if="parentCategory">
                                    <div class="category-navigation">
                                        <svg width="57" height="30" viewBox="0 0 57 30" fill="none"
                                             xmlns="http://www.w3.org/2000/svg"
                                             @click="parentNavigationUp(parentCategory)">
                                            <path d="M19.2096 17.625L26.5013 12.375L33.793 17.625" stroke="#6773AB"
                                                  stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                            <path
                                                d="M44.8386 0H0V30H57.0009L47.6847 2.05132C47.2763 0.82629 46.1299 0 44.8386 0Z"
                                                :fill="'#'+parentCategory.color_code" fill-opacity="1.0"/>
                                            <path d="M19.2096 16.625L26.5013 11.375L33.793 16.625" stroke="#6773AB"
                                                  stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                        <svg width="57" height="30" viewBox="0 0 57 30" fill="none"
                                             xmlns="http://www.w3.org/2000/svg"
                                             @click="parentNavigationDown(parentCategory)">
                                            <path
                                                d="M44.8377 30H0V0H57L47.6838 27.9487C47.2754 29.1737 46.129 30 44.8377 30Z"
                                                :fill="'#'+parentCategory.color_code" fill-opacity="0.7"/>
                                            <path d="M33.7904 12.375L26.4987 17.625L19.207 12.375" stroke="#3E4462"
                                                  stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </li>
                                <li v-if="subCategory"><a class="hide-cursor mr-0"
                                                          :style="'background-color: #' + parentCategory.color_code + '7F;'"
                                                          id="sub-category-link">
                                    <i class="fa fa-shopping-bag" aria-hidden="true"></i>{{ subCategory.name }}</a>
                                </li>
                                <li v-if="subCategory">
                                    <div class="category-navigation">
                                        <svg width="57" height="30" viewBox="0 0 57 30" fill="none"
                                             xmlns="http://www.w3.org/2000/svg"
                                             @click="subCategoryNavigationUp(subCategory)">
                                            <path d="M19.2096 17.625L26.5013 12.375L33.793 17.625" stroke="#6773AB"
                                                  stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                            <path
                                                d="M44.8386 0H0V30H57.0009L47.6847 2.05132C47.2763 0.82629 46.1299 0 44.8386 0Z"
                                                :fill="'#'+parentCategory.color_code" fill-opacity="0.7"/>
                                            <path d="M19.2096 16.625L26.5013 11.375L33.793 16.625" stroke="#6773AB"
                                                  stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                        <svg width="57" height="30" viewBox="0 0 57 30" fill="none"
                                             xmlns="http://www.w3.org/2000/svg"
                                             @click="subCategoryNavigationDown(subCategory)">
                                            <path
                                                d="M44.8377 30H0V0H57L47.6838 27.9487C47.2754 29.1737 46.129 30 44.8377 30Z"
                                                :fill="'#'+parentCategory.color_code" fill-opacity="0.4"/>
                                            <path d="M33.7904 12.375L26.4987 17.625L19.207 12.375" stroke="#3E4462"
                                                  stroke-opacity="0.5" stroke-width="2" stroke-linecap="round"
                                                  stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </li>
                            </template>
                        </ul>
                    </div>
                </base-section>
            </div>
            <template v-if="!isOrderHistoryView">
                <div v-if="is_free_item === false">
                    <b-overlay :show="loading" rounded="sm">
                        <base-section v-if="filteredItems.length > 0" class="pt-0">
                            <b-row>
                                <b-col cols="5">
                                    <h4 v-if="subCategory">Artikel</h4>
                                    <h4 v-else-if="parentCategory">Unterkategorien</h4>
                                </b-col>
                                <b-col cols="7">
                                    <div class="d-inline-flex float-right">
                                        <div class="d-flex justify-content-center flex-column">
                                            <span class="mr-4">Zeige {{ meta.current_page }} von {{
                                                    meta.last_page
                                                }}</span>
                                        </div>
                                        <b-button
                                            variant="outline-secondary pagination-button"
                                            class="mr-4"
                                            @click="previousPage"
                                        >Vorherige
                                        </b-button>
                                        <b-button
                                            variant="outline-secondary pagination-button"
                                            @click="nextPage"
                                        >Nächste
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </base-section>
                        <b-row>
                            <b-col cols="3" v-for="(categoryItem, index) in filteredItems" :key="index"
                                   class="mt-3 cols-5th">
                                <div
                                    v-if="categoryItem.is_parent || categoryItem.is_sub_category"
                                    class="category-box"
                                    :style="'background-color: #' + categoryItem.color_code + ' !important;'"
                                    @click="updateTree(categoryItem)"
                                >
                                    <span class="category-item-box">{{ categoryItem.name }}</span>
                                </div>
                                <div v-else-if="categoryItem.is_item === 1"
                                     class="category-box"
                                     :style="'background-color: #' + categoryItem.color_code + '90 !important;'"
                                     @click="addToCart(categoryItem)"
                                >
                                <span class="category-item-box">{{ categoryItem.name }}
                                    <strong>{{ parseFloat(categoryItem.price).toFixed(2) }}</strong> €
                                </span>
                                </div>
                                <div class="return-item-label-box">
                                    <span class="return-item-label mr-1"
                                          v-if="categoryItem.is_deposit === 1">Retour</span>
                                    <img
                                        v-if="categoryItem.deposits && categoryItem.deposits.length > 0 || categoryItem.is_deposit === 1"
                                        :src="require('../assets/recycle.svg')"
                                    >
                                </div>
                            </b-col>
                        </b-row>

                        <base-section v-if="itemsWithoutSubcategory.length > 0" class="mt-4 pt-0">
                            <b-row>
                                <b-col cols="5">
                                    <h4 v-if="itemsWithoutSubcategory.length > 0">Keine Unterkategorie</h4>
                                    <h4 v-else>Artikel</h4>
                                </b-col>
                                <b-col cols="7">
                                    <div class="d-inline-flex float-right">
                                        <div class="d-flex justify-content-center flex-column">
                                        <span class="mr-4">Zeige {{
                                                itemsWithoutSubcategoryMeta.current_page
                                            }} von {{ itemsWithoutSubcategoryMeta.last_page }}</span>
                                        </div>
                                        <b-button
                                            variant="outline-secondary pagination-button"
                                            class="mr-4"
                                            @click="itemsWithoutSubcategoryPreviousPage"
                                        >Vorherige
                                        </b-button>
                                        <b-button
                                            variant="outline-secondary pagination-button"
                                            @click="itemsWithoutSubcategoryNextPage"
                                        >Nächste
                                        </b-button>
                                    </div>
                                </b-col>
                            </b-row>
                        </base-section>
                        <b-row>
                            <b-col cols="3" v-for="(categoryItem, index) in itemsWithoutSubcategory" :key="index"
                                   class="mt-3 cols-5th">
                                <div class="category-box"
                                     :style="'background-color: #' + categoryItem.color_code + '90 !important;'"
                                     @click="addToCart(categoryItem)">
                                <span class="category-item-box">{{
                                        categoryItem.name
                                    }} <strong>{{ parseFloat(categoryItem.price).toFixed(2) }}</strong> €</span>
                                </div>
                                <div class="return-item-label-box">
                                    <span class="return-item-label mr-1"
                                          v-if="categoryItem.is_deposit === 1">Retour</span>
                                    <img
                                        v-if="categoryItem.deposits && categoryItem.deposits.length > 0 || categoryItem.is_deposit === 1"
                                        :src="require('../assets/recycle.svg')">
                                </div>
                            </b-col>
                        </b-row>
                    </b-overlay>
                </div>
                <div v-else>
                    <base-section>
                        <b-row class="mb-4">
                            <b-col cols="9">
                                <b-form-group
                                    id="input-group-free_item_name"
                                    label="Name"
                                    label-for="input-free_item_name"
                                >
                                    <template v-slot:label>
                                        <strong>Name</strong>
                                    </template>
                                    <b-input-group>
                                        <b-form-input
                                            v-model="freeItemName"
                                            ref="freeitemname"
                                            type="text"
                                            placeholder="Name"
                                            autocomplete="off"
                                        ></b-form-input>
                                        <b-input-group-append v-if="freeItemName" @click="freeItemName = null">
                                            <b-input-group-text>
                                                <b-icon icon="x"/>
                                            </b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback :state="validation['free_item_name']['state']"
                                                             class="mt-2">
                                        * {{ validation['free_item_name']['message'] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="3">
                                <b-form-group
                                    id="input-group-free_item_price"
                                    label="Price"
                                    label-for="input-free_item_price"
                                >
                                    <template v-slot:label>
                                        <strong>Preis</strong>
                                    </template>
                                    <b-input-group>
                                        <b-form-input
                                            v-model="freeItemPrice"
                                            type="text"
                                            placeholder="Preis"
                                            autocomplete="off"
                                            @keypress="isFloat($event)"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-input-group-text>€</b-input-group-text>
                                        </b-input-group-append>
                                        <b-input-group-append v-if="freeItemPrice" @click="freeItemPrice = null">
                                            <b-input-group-text>
                                                <b-icon icon="x"/>
                                            </b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback :state="validation['free_item_price']['state']"
                                                             class="mt-2">
                                        * {{ validation['free_item_price']['message'] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col>
                                <b-form-group label="MwSt" v-slot="{ ariaDescribedby }" class="tax-rate-label">
                                    <b-form-radio-group
                                        id="free-item-vat"
                                        v-model="freeItemVat"
                                        :options="options"
                                        class="free-item-vat"
                                        :aria-describedby="ariaDescribedby"
                                        name="free-item-vat"
                                        buttons
                                    ></b-form-radio-group>
                                    <b-form-invalid-feedback :state="validation['free_item_vat']['state']" class="mt-2">
                                        * {{ validation['free_item_vat']['message'] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col cols="3" class="offset-9">
                                <b-button
                                    class="submit-button submit-free-item"
                                    variant="primary"
                                    block
                                    @click="addFreeIntoCart"
                                >
                                    + In den Warenkorb legen
                                </b-button>
                            </b-col>
                        </b-row>
                    </base-section>
                </div>
            </template>
            <order-history
                v-else
                ref="order-history"
                :consumer="selectedKioskConsumer"
                :return-items-cart="returnItemsCart"
                :is-loading="isOrderHistoryLoading"
                @return="addToReturnItemsCart"
            ></order-history>
        </b-col>

        <div class="sticky-cart p-4 none" id="sticky-cart" v-if="selectedKioskConsumer && portrait">
            <b-col>
                <template v-if="!isOrderHistoryView">
                    <b-row>
                        <b-col cols="5">
                            <b-row>
                                <b-col cols="9">
                                    <h5>
                                        <img :src="require('../assets/user.svg')" alt="Logo" class="mr-2">
                                        <strong>
                                            {{ selectedKioskConsumer.firstname }} {{ selectedKioskConsumer.lastname }}
                                        </strong>
                                    </h5>
                                </b-col>
                                <b-col>
                                    <img
                                        class="history-icon"
                                        :src="require('../assets/history_icon.svg')"
                                        alt="Order history"
                                        @click="handleOrderHistoryBtnClick"
                                    >
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="3">Guthaben: <strong>€ {{ selectedKioskConsumer.coefficient }}</strong></b-col>
                        <b-col class="d-flex justify-content-end flex-row" v-if="cart.length > 0">
                            <h5>
                                <strong>Gesamtpreis: {{ getCartTotalPrice(cart).toFixed(2) }} €</strong>
                            </h5>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3">
                        <b-col>
                            <b-row v-for="(cartItem, index) in cart" :key="index" class="mb-2">
                                <b-col cols="1">
                                    {{ index + 1 }}.
                                </b-col>
                                <b-col cols="5">
                                    <div>{{ cartItem.name }}</div>
                                    <div>
                                        {{ parseFloat(cartItem.price).toFixed(2) }} €
                                        <img
                                            v-if="cartItem.is_deposit === 1 && cartItem.is_parent_item === 1"
                                            :src="require('../assets/retour_green_icon.svg')"
                                        >
                                    </div>
                                    <div v-for="(deposit, depositIndex) in cartItem.deposits" :key="depositIndex">
                                        <div>{{ deposit.name }}</div>
                                        <div>
                                            {{ parseFloat(deposit.price).toFixed(2) }} €
                                            <img class="ml-1" :src="require('../assets/recycle.svg')" alt="Deposit">
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="3">
                                    <b-row>
                                        <img @click="decrease(index)" :src="require('../assets/minus_button.svg')">
                                        <div class="mr-2 ml-2 d-flex justify-content-center flex-column">
                                            {{ cartItem.quantity }}
                                        </div>
                                        <img @click="increase(index)" :src="require('../assets/plus_button.svg')">
                                    </b-row>
                                </b-col>
                                <b-col>
                                    {{ getCartItemTotalPrice(cartItem).toFixed(2) }} €
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col cols="3">
                            <b-button
                                v-if="cart.length > 0 && parseGermanFloat(selectedKioskConsumer.coefficient) >= getCartTotalPrice(cart)"
                                variant="primary"
                                block
                                @click="createOrder"
                                :disabled="loading"
                            >
                                Einreichen
                            </b-button>
                            <b-button
                                class="cancel-button"
                                id="cancel-button-right"
                                block
                                @click="clearCartAndUser"
                            >
                                Stornieren
                            </b-button>
                        </b-col>
                    </b-row>
                </template>
                <return-items-cart
                    v-else
                    :is-landscape="false"
                    :cart="returnItemsCart"
                    :disabled="loading"
                    @decrease="decreaseReturnItemQuantity"
                    @increase="increaseReturnItemQuantity"
                    @return="createReturn"
                    @cancel="handleReturnItemsCartCancel"
                ></return-items-cart>
            </b-col>
        </div>

        <b-col cols="4" class="p-4 cart" id="cart" v-if="selectedKioskConsumer && landscape">
            <template v-if="!isOrderHistoryView">
                <div>
                    <b-row class="consumer-info mb-4 justify-content-between align-items-center">
                        <b-col sm="9" xl="10">
                            <b-row>
                                <b-col>
                                    <h5>
                                        <img :src="require('../assets/user.svg')" alt="Logo" class="mr-2">
                                        <strong>
                                            {{ selectedKioskConsumer.firstname }} {{ selectedKioskConsumer.lastname }}
                                        </strong>
                                    </h5>
                                </b-col>
                            </b-row>
                            <b-row class="d-flex justify-content-between flex-row">
                                <b-col class="float-left">
                                    Guthaben: <strong>€ {{ selectedKioskConsumer.coefficient }}</strong>
                                </b-col>
                            </b-row>
                            <b-row class="d-flex justify-content-between flex-row">
                                <b-col class="float-left">
                                    Tageslimit: <strong>{{ getKioskLimitDescription(selectedKioskConsumer) }}</strong>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="text-right">
                            <img
                                class="history-icon"
                                :src="require('../assets/history_icon.svg')"
                                alt="Order history"
                                @click="handleOrderHistoryBtnClick"
                            >
                        </b-col>
                    </b-row>

                    <b-row class="mt-4 cart-items">
                        <ol class="w-100">
                            <li v-for="(cartItem, index) in cart" :key="index">
                                <b-row class="mb-4 w-100">
                                    <b-col cols="7">
                                        <div>{{ cartItem.name }}</div>
                                        <div>
                                            {{ parseFloat(cartItem.price).toFixed(2) }} €
                                            <img
                                                v-if="cartItem.is_deposit === 1 && cartItem.is_parent_item === 1"
                                                :src="require('../assets/retour_green_icon.svg')"
                                            >
                                        </div>
                                        <div v-for="(deposit, depositIndex) in cartItem.deposits" :key="depositIndex">
                                            <div>{{ deposit.name }}</div>
                                            <div>
                                                {{ parseFloat(deposit.price).toFixed(2) }} €
                                                <img class="ml-1" :src="require('../assets/recycle.svg')" alt="Deposit">
                                            </div>
                                        </div>
                                    </b-col>
                                    <b-col cols="5">
                                        <b-row class="justify-content-center">
                                            <img @click="decrease(index)" :src="require('../assets/minus_button.svg')">
                                            <div class="mr-2 ml-2 d-flex justify-content-center flex-column">
                                                {{ cartItem.quantity }}
                                            </div>
                                            <img @click="increase(index)" :src="require('../assets/plus_button.svg')">
                                        </b-row>
                                    </b-col>
                                </b-row>
                            </li>
                        </ol>
                    </b-row>
                </div>

                <div class="buttons">
                    <b-row class="mt-5" v-if="cart.length > 0">
                        <b-col>
                            <h5><strong>Gesamtpreis: {{ getCartTotalPrice(cart).toFixed(2) }} €</strong></h5>
                        </b-col>
                    </b-row>

                    <b-row
                        class="d-flex justify-content-center flex-row mt-5"
                        v-if="cart.length > 0 && parseGermanFloat(selectedKioskConsumer.coefficient) >= getCartTotalPrice(cart)"
                    >
                        <b-col>
                            <b-button
                                class="submit-button"
                                variant="primary"
                                block
                                @click="createOrder"
                                :disabled="loading"
                            >
                                Einreichen
                            </b-button>
                        </b-col>
                    </b-row>

                    <b-row class="d-flex justify-content-center flex-row mt-3">
                        <b-col>
                            <b-button class="cancel-button" id="cancel-button-bottom" block @click="clearCartAndUser">
                                Stornieren
                            </b-button>
                        </b-col>
                    </b-row>
                </div>
            </template>
            <return-items-cart
                v-else
                :cart="returnItemsCart"
                :disabled="loading"
                @decrease="decreaseReturnItemQuantity"
                @increase="increaseReturnItemQuantity"
                @return="createReturn"
                @cancel="handleReturnItemsCartCancel"
            ></return-items-cart>
        </b-col>
    </b-row>
</template>

<script>
import {mapActions, mapGetters, mapState}                                                                                                               from "vuex";
import BaseSection                                                                                                                                      from "@/components/base/Section";
import OrderHistory                                                                                                                                     from "@/components/orders/OrderHistory";
import ReturnItemsCart                                                                                                                                  from "@/components/cart/ReturnItemsCart";
import {createKioskOrder, createKioskReturn, getKioskCategories, getKioskItems, getKioskSubCategories, hasCateringCategorySubcategories, hasKioskItems} from "@/api/kiosk";
import FooveAutocomplete                                                                                                                                from '@/components/autocomplete/Autocomplete.vue';
import moment                                                                                                                                           from "moment";
import cartMixin                                                                                                                                        from "@/mixins/cartMixin";

export default {
    name:       'Kiosk',
    components: {FooveAutocomplete, BaseSection, OrderHistory, ReturnItemsCart},
    mixins:     [cartMixin],
    data() {
        return {
            items:                          [],
            filteredItems:                  [],
            allKioskCategories:             [],
            allKioskSubCategories:          [],
            kioskSubcategoriesPerPage:      20,
            itemsWithoutSubcategory:        [],
            itemsWithoutSubcategoryMeta:    [],
            itemsWithoutSubcategoryLinks:   [],
            itemsWithoutSubcategoryPerPage: 5,
            cart:                           [],
            meta:                           [],
            links:                          [],
            freeItemName:                   null,
            freeItemPrice:                  null,
            freeItemVat:                    null,
            loading:                        false,
            parentCategory:                 false,
            subCategory:                    false,
            isSubTree:                      false,
            isItemsTree:                    false,
            portrait:                       false,
            landscape:                      false,
            is_free_item:                   false,
            options:                        [
                {text: '0%', value: '0'},
                {text: '7%', value: '7'},
                {text: '19%', value: '19'}
            ],
            validation:                     {
                'free_item_name':  {'state': true, 'message': ''},
                'free_item_price': {'state': true, 'message': ''},
                'free_item_vat':   {'state': true, 'message': ''},
            },
            isOrderHistoryView:             false,
            isOrderHistoryLoading:          false,
            returnItemsCart:                [],
            enableSearch:                   false,
        };
    },
    computed: {
        ...mapGetters(['selectedKioskConsumer']),
        ...mapState(['auth']),
        currentDate() {
            return moment(new Date).format('DD.MM.YY');
        },
        isAllowToOrder() {
            return (this.selectedKioskConsumer) ? this.selectedKioskConsumer.is_allow_cash_register : true;
        }
    },
    async created() {
        this.loading = true;
        let response = await getKioskCategories();

        this.filteredItems      = response['data']['data'];
        this.allKioskCategories = response['data']['data'];
        this.meta               = response['data']['meta'];
        this.links              = response['data']['links'];
        this.loading            = false;
    },
    methods: {
        parseGermanFloat(value) {
            if (typeof value === 'number') return value;
            if (!value) return 0;
            return parseFloat(String(value).replace(/\./g, '').replace(',', '.'));
        },
        clearSearchInput() {
            if (this.$refs.kioskautocomplete) {
                this.$refs.kioskautocomplete.value = '';
            }
        },
        async parentNavigationUp(parentCategory) {
            const self = this;

            let parentCategoryIndex = self.allKioskCategories.findIndex(function (category) {
                return parentCategory.id === category.id
            })

            if (self.allKioskCategories[parentCategoryIndex + 1]) {
                if (self.allKioskCategories[parentCategoryIndex].is_free_item_category === 1) {
                    self.is_free_item = false;
                }
                await self.updateTree(self.allKioskCategories[parentCategoryIndex + 1]);
            } else {
                if (self.allKioskCategories[parentCategoryIndex].is_free_item_category === 1) {
                    self.is_free_item = false;
                }
                await self.updateTree(self.allKioskCategories[0]);
            }

            self.subCategory = false;
            self.isSubTree   = false;
        },
        async parentNavigationDown(parentCategory) {
            const self = this;

            let parentCategoryIndex = self.allKioskCategories.findIndex(function (category) {
                return parentCategory.id === category.id
            })

            if (self.allKioskCategories[parentCategoryIndex - 1]) {
                if (self.allKioskCategories[parentCategoryIndex].is_free_item_category === 1) {
                    self.is_free_item = false;
                }
                await self.updateTree(self.allKioskCategories[parentCategoryIndex - 1]);
            } else {
                if (self.allKioskCategories[parentCategoryIndex].is_free_item_category === 1) {
                    self.is_free_item = false;
                }
                await self.updateTree(self.allKioskCategories[self.allKioskCategories.length - 1]);
            }

            self.subCategory = false;
            self.isSubTree   = false;
        },
        async subCategoryNavigationUp(subCategory) {
            const self = this;

            let subCategoryIndex = self.allKioskSubCategories.findIndex(function (sub) {
                return subCategory.id === sub.id
            })

            if (self.allKioskSubCategories[subCategoryIndex + 1]) {
                await self.updateTree(self.allKioskSubCategories[subCategoryIndex + 1]);
            } else {
                await self.updateTree(self.allKioskSubCategories[0]);
            }
        },
        async subCategoryNavigationDown(subCategory) {
            const self = this;

            let subCategoryIndex = self.allKioskSubCategories.findIndex(function (sub) {
                return subCategory.id === sub.id
            })

            if (self.allKioskSubCategories[subCategoryIndex - 1]) {
                await self.updateTree(self.allKioskSubCategories[subCategoryIndex - 1]);
            } else {
                await self.updateTree(self.allKioskSubCategories[self.allKioskSubCategories.length - 1]);
            }
        },
        ...mapActions(['setSelectedKioskConsumer', 'setIntervalId', 'setAutocompleteFocus']),
        isFloat: function (evt) {
            evt          = (evt) ? evt : window.event;
            let charCode = (evt.which) ? evt.which : evt.keyCode;

            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 44) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        addFreeIntoCart() {
            if (!this.selectedKioskConsumer) {
                return;
            }

            if (!this.freeItemName || !this.freeItemPrice || !this.freeItemVat) {
                if (!this.freeItemName) {
                    this.validation['free_item_name']['state']   = false;
                    this.validation['free_item_name']['message'] = 'Name ist erforderlich';
                }

                if (!this.freeItemPrice) {
                    this.validation['free_item_price']['state']   = false;
                    this.validation['free_item_price']['message'] = 'Preis ist erforderlich';
                }

                if (!this.freeItemVat) {
                    this.validation['free_item_vat']['state']   = false;
                    this.validation['free_item_vat']['message'] = 'MwSt ist erforderlich';
                }

                return;
            }

            if (this.freeItemName && this.freeItemPrice && this.freeItemVat) {
                this.cart.push({
                    'id':                   null,
                    'name':                 this.freeItemName,
                    'tax_rate':             this.freeItemVat,
                    'price':                this.freeItemPrice.replace(',', '.'),
                    'catering_category_id': this.parentCategory.id,
                    'quantity':             1,
                    'is_item':              1,
                    'is_free_item':         1,
                });

                this.freeItemName  = null;
                this.freeItemPrice = null;
                this.freeItemVat   = null;
            }
        },
        async handleSubmit(result) {
            if (typeof result == 'undefined') return;

            this.value = '';
            if (this.$refs.autocomplete)
                this.$refs.autocomplete.clearSearchInput();

            if (this.cart.length === 0 && this.returnItemsCart.length === 0) {
                this.setSelectedKioskConsumer(result);

                if (this.isOrderHistoryView) {
                    await this.$refs['order-history'].loadOrderHistory();
                }
            }

            await this.detectDevice();
        },
        async backHome() {
            this.loading = true;
            this.clearOrderHistoryViewData();

            let response = await getKioskCategories();

            this.filteredItems      = response['data']['data'];
            this.allKioskCategories = response['data']['data'];
            this.meta               = response['data']['meta'];
            this.links              = response['data']['links'];

            this.parentCategory          = false;
            this.subCategory             = false;
            this.isItemsTree             = false;
            this.isSubTree               = false;
            this.loading                 = false;
            this.is_free_item            = false;
            this.itemsWithoutSubcategory = [];
        },
        async createOrder() {
            if (this.selectedKioskConsumer) {
                this.loading = true;
                try {
                    let response = await createKioskOrder({
                        user_id: this.selectedKioskConsumer.consumer_id,
                        items:   this.cart,
                        total:   this.getCartTotalPrice(this.cart),
                    });

                    if (response.success) {
                        this.$bvToast.toast(response.message, {
                            toaster:       'b-toaster-top-center',
                            title:         'success',
                            variant:       'success',
                            autoHideDelay: 7000,
                        });

                        this.cart = [];
                    }

                    await this.clearCartAndUser();
                    await this.backHome();
                    this.loading = false;
                } catch (error) {
                    this.loading = false;
                }
            }
        },
        async createReturn() {
            if (!this.selectedKioskConsumer) return;
            this.loading = true;

            let response = await createKioskReturn({
                user_id: this.selectedKioskConsumer.consumer_id,
                items:   this.returnItemsCart,
                total:   this.getCartTotalPrice(this.returnItemsCart),
            });

            if (response.success) {
                this.$bvToast.toast(response.message, {
                    toaster:       'b-toaster-top-center',
                    title:         'success',
                    variant:       'success',
                    autoHideDelay: 7000,
                });
            }

            this.setSelectedKioskConsumer(null);
            await this.backHome();
            this.loading = false;
        },
        async previousPage() {
            await this.paginate('prev')
        },
        async nextPage() {
            await this.paginate('next')
        },
        async itemsWithoutSubcategoryPreviousPage() {
            await this.paginateItemsWithoutSubcategory('prev');
        },
        async itemsWithoutSubcategoryNextPage() {
            await this.paginateItemsWithoutSubcategory('next');
        },
        async paginate(direction) {
            if (this.links[direction] === null) {
                return
            }

            const url         = new URL(this.links[direction]);
            const queryString = new URLSearchParams(url.search);

            if (!queryString.has('page')) {
                return
            }

            let curPage = queryString.get('page');
            if (this.isItemsTree) {
                await this.loadKioskItems({catering_category_id: this.subCategory.id, page: curPage});
            } else if (this.isSubTree) {
                this.loading = true;
                await this.loadKioskSubCategories({parent_id: this.parentCategory.id, page: curPage});
                this.loading = false;
            } else {
                await this.loadKioskCategories({page: curPage});
            }
        },
        async paginateItemsWithoutSubcategory(direction) {
            if (this.itemsWithoutSubcategoryLinks[direction] === null) return;

            const url         = new URL(this.itemsWithoutSubcategoryLinks[direction]);
            const queryString = new URLSearchParams(url.search);

            if (!queryString.has('page')) return;

            const curPage = queryString.get('page');

            this.loading = true;
            await this.loadKioskItemsWithoutSubcategory({catering_category_id: this.parentCategory.id, page: curPage});
            this.loading = false;
        },
        async loadKioskItems(obj) {
            this.loading = true;
            let response = await getKioskItems(obj);

            if (response['data']['data']) {
                this.filteredItems = response['data']['data'];
                this.meta          = response['data']['meta'];
                this.links         = response['data']['links'];
            }

            this.loading = false;
        },
        async loadKioskItemsWithoutSubcategory(obj) {
            obj.itemsPerPage = this.itemsWithoutSubcategoryPerPage;
            let response     = await getKioskItems(obj);

            if (response['data']['data']) {
                this.itemsWithoutSubcategory      = response['data']['data'];
                this.itemsWithoutSubcategoryMeta  = response['data']['meta'];
                this.itemsWithoutSubcategoryLinks = response['data']['links'];
            }
        },
        async loadKioskSubCategories(obj) {
            obj.itemsPerPage = this.kioskSubcategoriesPerPage;
            let response     = await getKioskSubCategories(obj);

            if (response['data']['data']) {
                this.filteredItems         = response['data']['data'];
                this.allKioskSubCategories = response['data']['data'];
                this.meta                  = response['data']['meta'];
                this.links                 = response['data']['links'];
            }
        },
        async loadKioskCategories(obj) {
            this.loading = true;
            let response = await getKioskCategories(obj);

            if (response['data']['data']) {
                this.filteredItems      = response['data']['data'];
                this.allKioskCategories = response['data']['data'];
                this.meta               = response['data']['meta'];
                this.links              = response['data']['links'];
            }

            this.loading = false;
        },
        async setPerPageOptions(categoryId) {
            const [hasSubcategoriesResponse, hasKioskItemsResponse] = await Promise.all([
                hasCateringCategorySubcategories(categoryId),
                hasKioskItems({catering_category_id: categoryId})
            ]);

            const hasSubcategories = hasSubcategoriesResponse['data']['data'];
            const hasItems         = hasKioskItemsResponse['data']['data'];

            if (hasSubcategories && hasItems) {
                this.kioskSubcategoriesPerPage      = 10;
                this.itemsWithoutSubcategoryPerPage = 5;
            } else {
                this.kioskSubcategoriesPerPage      = 20;
                this.itemsWithoutSubcategoryPerPage = 20;
            }
        },
        async levelUp(selectedCategory) {
            if (this.subCategory) {
                this.loading = true;
                await this.setPerPageOptions(selectedCategory.id);
                await this.loadKioskSubCategories({parent_id: selectedCategory.id});
                await this.loadKioskItemsWithoutSubcategory({catering_category_id: selectedCategory.id});

                this.subCategory = false;
                this.isItemsTree = false;
                this.loading     = false;
            }
        },
        async updateTree(selectedCategory) {
            if (selectedCategory.is_free_item_category == 1) {
                this.is_free_item   = 1;
                this.parentCategory = selectedCategory;
                this.isSubTree      = true;

                setTimeout(function () {
                    let parentCategoryLink = document.getElementById("parent-category-link");

                    parentCategoryLink.style.setProperty("--breadcrumbs", "#" + selectedCategory.color_code);
                }, 1);

                return;
            }

            if (selectedCategory.is_parent) {
                this.loading = true;

                if (selectedCategory.id) {
                    await this.setPerPageOptions(selectedCategory.id);
                    await this.loadKioskSubCategories({parent_id: selectedCategory.id});
                    await this.loadKioskItemsWithoutSubcategory({catering_category_id: selectedCategory.id});
                } else {
                    this.filteredItems                  = [];
                    this.itemsWithoutSubcategoryPerPage = 20;
                    await this.loadKioskItemsWithoutSubcategory({catering_category_id: null});
                }

                this.parentCategory = selectedCategory;
                this.isSubTree      = true;
                setTimeout(function () {
                    let parentCategoryLink = document.getElementById("parent-category-link");

                    parentCategoryLink.style.setProperty("--breadcrumbs", "#" + selectedCategory.color_code);
                }, 1)

                this.loading = false
            } else if (selectedCategory.is_sub_category) {
                this.itemsWithoutSubcategory = [];
                await this.loadKioskItems({catering_category_id: selectedCategory.id});

                this.subCategory = selectedCategory;
                this.isItemsTree = true;

                setTimeout(function () {
                    let parentCategoryLink = document.getElementById("sub-category-link");

                    parentCategoryLink.style.setProperty("--breadcrumbs", "#" + selectedCategory.color_code + '90');
                }, 1)
                this.loading = false;
            }
        },
        addToCart(categoryItem) {
            if (!this.selectedKioskConsumer) return;

            let isItemExists = this.cart.find(function (item) {
                return item.id === categoryItem.id && item.is_parent_item === categoryItem.is_parent_item
            })

            if (isItemExists) return;

            let cartItem = Object.assign({}, categoryItem);

            cartItem.quantity = 1;

            if (cartItem.is_deposit === 1) {
                cartItem.refund = 1;
                cartItem.price *= -1;
            }

            this.cart.push(cartItem);
        },
        addToReturnItemsCart(orderedItem) {
            if (!this.selectedKioskConsumer) return;

            const isItemExistsInCart = this.returnItemsCart.find(function (item) {
                return item.id === orderedItem.id;
            })

            if (isItemExistsInCart) return;

            if (orderedItem.returnable_quantity === 0) return;

            const cartItem = Object.assign({}, orderedItem);

            cartItem.quantity = 1;

            this.returnItemsCart.push(cartItem);
        },
        async clearCartAndUser() {
            this.setSelectedKioskConsumer(null);
            this.clearFreeItemData();
            this.cart = [];
        },
        clearFreeItemData() {
            this.freeItemName  = null;
            this.freeItemPrice = null;
            this.freeItemVat   = null;
        },
        handleReturnItemsCartCancel() {
            this.setSelectedKioskConsumer(null);
            this.backHome();
        },
        clearOrderHistoryViewData() {
            this.returnItemsCart    = [];
            this.isOrderHistoryView = false;
        },
        async increase(cartItemIndex) {
            if (!this.isAllowToOrder) return;

            this.cart[cartItemIndex].quantity++;
        },
        increaseReturnItemQuantity(index) {
            const newQuantity = this.returnItemsCart[index].quantity + 1;

            if (newQuantity > this.returnItemsCart[index].returnable_quantity) return;

            this.returnItemsCart[index].quantity = newQuantity;
        },
        async decrease(cartItemIndex) {
            if (!this.isAllowToOrder) return;

            this.cart[cartItemIndex].quantity--;

            if (this.cart[cartItemIndex].quantity === 0) {
                this.cart.splice(cartItemIndex, 1);
            }
        },
        decreaseReturnItemQuantity(index) {
            this.returnItemsCart[index].quantity--;

            if (this.returnItemsCart[index].quantity === 0) {
                this.returnItemsCart.splice(index, 1);
            }
        },
        async detectDevice() {
            if (window.matchMedia("(orientation: portrait)").matches) {
                this.portrait  = true;
                this.landscape = false;

                let stickyCart = document.getElementById("sticky-cart");
                if (stickyCart)
                    stickyCart.style = 'display: block !important;';

                let blockInfo = document.getElementById("block-info");
                if (blockInfo)
                    blockInfo.style = 'flex: 0 0 100% !important;max-width: 100% !important;';

                let cart = document.getElementById("cart");
                if (cart)
                    cart.style = 'display: none !important;';
            }

            if (window.matchMedia("(orientation: landscape)").matches) {
                this.landscape = true;
                this.portrait  = false;

                let stickyCart = document.getElementById("sticky-cart");
                if (stickyCart)
                    stickyCart.style = 'display: none !important;';
            }
        },
        async handleOrderHistoryBtnClick() {
            if (!this.isAllowToOrder) return;

            this.clearFreeItemData();
            this.cart               = [];
            this.isOrderHistoryView = true;
        },
        getKioskLimitDescription(consumer) {
            return consumer?.kiosk_daily_limit ? `€ ${consumer.kiosk_daily_limit}` : 'Unbegrenzt';
        }
    },
    async mounted() {
        if (this.$refs.kioskautocomplete && !this.selectedKioskConsumer) {
            this.$refs.kioskautocomplete.$refs.input.focus();
        }

        if (this.$refs.freeitemname && this.selectedKioskConsumer && this.$refs.freeitemname.value === null) {
            this.$refs.freeitemname.$refs.input.focus();
        }

        await this.detectDevice();
    },
    watch: {
        freeItemName:  {
            handler() {
                this.validation['free_item_name']['state']   = true;
                this.validation['free_item_name']['message'] = '';
            }
        },
        freeItemPrice: {
            handler() {
                this.validation['free_item_price']['state']   = true;
                this.validation['free_item_price']['message'] = '';
            }
        },
        freeItemVat:   {
            handler() {
                this.validation['free_item_vat']['state']   = true;
                this.validation['free_item_vat']['message'] = '';
            }
        }
    }
}
</script>

<style lang="scss">

:root {
    --breadcrumbs: #F8F5F2;
}

html {
    height: 100%;
}

body {
    height: 100%;
}

.return-item-label {
    color: #388E3C;
    font-style: italic;
    font-weight: 700 !important;
}

.return-item-label-box {
    position: absolute;
    top: 3px;
    right: 25px;
}

.sticky-cart {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: rgb(248, 245, 242)
}

.free-item-vat label.btn-secondary {
    border-radius: 10px !important;
    color: #3E4462 !important;
    background-color: #F8F5F2 !important;
    border-color: #F8F5F2 !important;
    margin-right: 20px !important;
    height: 95px !important;
    width: 104px !important;
    display: flex !important;
    justify-content: center !important;
    flex-direction: column !important;
    box-shadow: rgb(0 0 0 / 15%) 0px 3px 3px 0px !important;
}

.free-item-vat label.btn-secondary.active {
    border: 2px #b14d42 solid !important;
}

.tax-rate-label legend {
    font-weight: bolder !important;
}

.autocomplete-result-list {
    z-index: 10 !important;
}

.app-wrapper {
    height: 100%;
}

.hide-cursor {
    cursor: pointer;
    user-select: none;
}

.cart {
    background-color: #F8F5F2;
}

.category-item-box {
    font-size: 1rem !important;
}

.submit-button {
    color: #FFFFFF;
    height: 44px;
}

.submit-free-item {
    font-size: 0.8rem !important;
}

.cancel-button {
    background-color: #DFDFDF !important;
    border-color: #DFDFDF !important;
    color: #3E4462 !important;
    height: 44px;
}

#cancel-button-right:hover {
    background-color: #DFDFDF !important;
    border-color: #DFDFDF !important;
}

#cancel-button-bottom:hover {
    background-color: #DFDFDF !important;
    border-color: #DFDFDF !important;
}

.category-box {
    cursor: pointer;
    user-select: none;
    overflow-wrap: anywhere;
    background-color: rgb(208, 209, 251);
    height: 100px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.15) 0px 3px 3px 0px;
}

.pagination-button {
    color: #374151;
    border-color: #D1D5DB;
}

.main-info-wrapper {
    height: 100%;
}

.cols-5th {
    flex: 0 0 20% !important;
    max-width: 20% !important;
}

/*crumbs*/
#crumbs h1 {
    padding: 0 0 30px;
    text-transform: uppercase;
    font-size: 0.9rem;
    font-weight: 600;
    letter-spacing: 0.01rem;
    color: #8093A7;
}

#crumbs ul {
    list-style: none;
    display: inline-flex;
    padding-left: 0px;
}

#crumbs ul li {
    display: inline;
}

#crumbs ul li a {
    display: block;
    float: left;
    height: 60px;
    background: #F8F5F2;
    text-align: center;
    padding: 18px 10px 0 38px;
    position: relative;
    margin: 0 4px 0 0;
    font-size: 1rem;
    text-decoration: none;
    color: #3E4462;
}

#crumbs ul li a.only-first:after {
    content: "";
    border-top: 31px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 10px solid var(--breadcrumbs, #61d345);
    position: absolute;
    right: -10px;
    top: 0;
    z-index: 1;
}

#crumbs ul li a:before {
    content: "";
    border-top: 31px solid transparent;
    border-bottom: 30px solid transparent;
    border-left: 11px solid #ffffff;
    position: absolute;
    left: 0;
    top: 0;
}

#crumbs ul li:first-child a {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding-left: 20px;
}

#crumbs ul li:first-child a:before {
    display: none;
}

.kiosk-overlay {
    position: absolute;
    width: 100%;
    height: calc(100% - 20%);
    background: rgba(255, 255, 255, .9);
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    left: -15px;
    margin-top: 20px;
    padding-left: 30px;
    text-align: center;
}

.category-navigation {
    display: flex !important;
    justify-content: center !important;
    flex-direction: column !important;
}

.history-icon {
    &:hover {
        cursor: pointer;
    }
}

</style>
